import type { ISplittedNumberText } from "./settings.ts";

export function splitNumberParts(value: string): ISplittedNumberText {
  const parts: ISplittedNumberText = {};
  const v = value.trim();
  const pos = v.toLowerCase().indexOf("e");

  if (pos > -1) {
    parts.exponent = v.length > pos ? v.substr(pos + 1) : "";
    parts.mantissa = v.substr(0, pos);
  } else {
    parts.mantissa = v;
  }

  return parts;
}
